module.exports = __webpack_public_path__ + "img/Billable_Time_Spent.a8fbabe7.jpeg";